import { post } from "@/util/http";
const COS = require("cos-js-sdk-v5");
import { store } from "@/store/index.js";

export default {
  methods: {
    upload(file) {
      console.log(this.getFileNameFormat(file.name), "this.getFileNameFormat(file.name)");
      return new Promise((resolve, reject) => {
        post({ url: "/api/qcloud_sts" }).then(async (result) => {
          if (result.status === 200) {
            const res = result.data;
            if (res.status === 0) {
              // 初始化实例
              const cos = new COS({
                getAuthorization: function (options, callback) {
                  const credentials = res.data.Credentials;
                  callback({
                    TmpSecretId: credentials.TmpSecretId,
                    TmpSecretKey: credentials.TmpSecretKey,
                    XCosSecurityToken: credentials.Token,
                    ExpiredTime: res.data.ExpiredTime,
                  });
                },
                Domain: store.state.appConfig.img_upload_url,
              });

              cos.putObject(
                {
                  Bucket: res.data.bucket,
                  Region: res.data.region,
                  Key: "images/" + res.data.filename + this.getFileNameFormat(file.name),
                  // Body: base64File.slice(20) + base64File.slice(0, 20),
                  Body: file,
                },
                async function (err, data) {
                  if (err) {
                    resolve({ status: 1, msg: "上传失败" });
                  } else {
                    if (data.statusCode === 200) {
                      console.log("data.Location", data.Location);
                      let response = await fetch("https://" + data.Location);
                      let fetchData = await response.text();
                      // resolve({ status: 0, msg: "上传成功", data: fetchData.slice(-20) + fetchData.slice(0, fetchData.length - 20), key: "https://" + data.Location });
                      resolve({ status: 0, msg: "上传成功", data: "https://" + data.Location });
                    } else {
                      reject({ status: 1, msg: "上传失败" });
                    }
                  }
                }
              );
            }
          } else {
            resolve({ status: 1, msg: "上传失败" });
          }
        });
      });
    },
    getFileNameFormat(filename) {
      const myArray = filename.split(".");
      let formatName = "." + myArray.pop();
      return formatName;
    },
    uploadImgToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader(); //html5提供的一种异步文件读取机制
        reader.readAsDataURL(file); //将文件读取为Base64编码的数据URL
        reader.onload = function () {
          // 图片转base64完成后返回reader对象
          // var array = new Int8Array(reader.result);
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
  },
};
